<template>
  <input-widget :model="model" :attribute="attribute" :items="items" type="select2"
                value-field="key" :label="label" :options="computedOptions" :multiple="multiple"
                display-field="${item.text}"/>

</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import i18n from "@/shared/i18n";

  export default {
    name: "TemporaryItemPotentialSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true,
      },
      attribute: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: false,
        default: () => {
          return {placeholder: i18n.t('Potential')}
        }
      },
      multiple: {
        type: Boolean,
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
    },
    computed: {
      items() {
        return [
          {key: 'low', text: i18n.t('Low')},
          {key: 'middle', text: i18n.t('Middle')},
          {key: 'high', text: i18n.t('High')},
        ]
      },
      computedOptions() {
        return {...this.options, multiple: this.multiple}
      }
    }
  }
</script>

<style scoped>

</style>
